import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-experiencia-produtos',
  templateUrl: './card-experiencia-produtos.component.html',
  styleUrls: ['./card-experiencia-produtos.component.scss'],
})
export class CardExperienciaProdutosComponent implements OnInit {
  @Input() public id: number = null;
  @Input() public idGrupo: number = null;
  @Input() public preco: number = 0;
  @Input() public imagemSrc: string = '';
  @Input() public titulo: string = '';
  @Input() public descricao: string = '';
  @Input() public validade: Date = new Date();
  @Input() public nivel: string = '';
  @Input() public idNivelExperiencia: number = 0;
  @Input() public idNivelMembro: number = 0;
  @Input() public quantidadeDisponivel: number = 0;
  @Input() public tag: string = '';
  @Input() public destaque: boolean = false;
  @Input() public niveis: any[] = [];
  @Input() public nomeIdentificador: string;
  @Input() public precoEmCacaus: string;
  @Input() public estaEmMomentos: boolean = false;

  public experienciaNivelClasse: string = '';
  public experienciaEsgotada: boolean = false;
  public tagClasse: string = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.tratarDados();
  }

  onClick(): void {
    window.open(`/momento-especial/${this.nomeIdentificador}`, '_self');
  }

  private tratarDados(): void {
    this.experienciaEsgotada = this.quantidadeDisponivel === 0;
    this.definirClasse();
  }

  private definirClasse(): void {
    let classe = '';
    let classeDestaque = '';

    switch (this.nivel) {
      case 'crush':
        classe += 'nivel--crush ';
        classeDestaque = 'destaque--crush';
        break;
      case 'paixão':
        classe += 'nivel--paixao ';
        classeDestaque = 'destaque--paixao';
        break;
      case 'amor':
        classe += 'nivel--amor ';
        classeDestaque = 'destaque--amor';
        break;
      case 'paquera':
        classe += 'nivel--paquera ';
        classeDestaque = 'destaque--paquera';
        break;
    }

    if (!this.experienciaPertenceAoNivel())
      classe += 'experiencia--indisponivel ';

    if (this.destaque) classe += `experiencia--destaque ${classeDestaque} `;

    this.experienciaNivelClasse = classe;
  }

  private experienciaPertenceAoNivel(): boolean {
    return this.niveis.some((x) => x.idNivel == this.idNivelMembro);
  }
}
